import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { EventTypes, OidcSecurityService, PublicEventsService, UserDataResult } from 'angular-auth-oidc-client';
import { Observable } from 'rxjs';
import { Version } from './version';
import { AuthenticationService } from './auth/authentication-service';
import { environment } from 'src/environments/environment';
import { Const } from './const';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit {
  email: string | null = null;
  userData$: Observable<UserDataResult> = new Observable<UserDataResult>();
  year: number = Version.YEAR;
  version: string = Version.Version;
  env: string = environment.name == Const.PROD_ENV ? "" : environment.name;

  constructor(private router: Router,
    private location: Location,
    private authService: AuthenticationService,
    private oidcSecurityService: OidcSecurityService,
    private eventService: PublicEventsService) {

    //handles force firing of auth events
    //to enable silent token refresh
    //this is needed to keep the user logged in
    //when the app is reloaded when user is already logged in
    //and the token is still valid
    //
    //filtered out paths are handled by the login/logout components
    if (location.path() != "/login" && !location.path().startsWith("/callback") && location.path() != "/logout") {
      this.oidcSecurityService.checkAuth()
        .subscribe(({ isAuthenticated, userData, accessToken }) => {
          console.log(`app.component: isAuthenticated: ${isAuthenticated}`);
        });
    }

    //uncomment for auth logging
    this.eventService
      .registerForEvents()
      .subscribe((ev) => console.log(`Auth event with type ${EventTypes[ev.type]}`, ev.value));
  }

  ngOnInit(): void {
    this.authService.emailObservable.subscribe(email => this.email = email);
  }

  navigateToMainPage(): void {
    this.router.navigateByUrl("/");
  }

  logout(): void {
    this.authService.logout();
    this.email = null;
    this.router.navigateByUrl("/login");
  }
}
